"use client";

import { ITournamentFeedResponse } from "@finbackoffice/websocket-client";
import { FC, memo, useCallback, useContext } from "react";
import { PrematchContext } from "contexts";
import PrematchAllTournament from "./PrematchAllTournament";

interface IProps {
    tournaments: ITournamentFeedResponse[];
    sportSlug: string;
    sportId: number;
    categoryId: number;
    showCheckbox: boolean;
}

const PrematchAllTournamentsContainer: FC<IProps> = ({
    tournaments,
    categoryId,
    sportSlug,
    showCheckbox,
    sportId,
}) => {
    const { isTournamentSelected } = useContext(PrematchContext);

    const renderTournament = useCallback(
        (tournament: ITournamentFeedResponse) => {
            const isSelected = isTournamentSelected(tournament.id);
            return (
                <PrematchAllTournament
                    key={tournament.id}
                    tournament={tournament}
                    sportSlug={sportSlug}
                    sportId={sportId}
                    categoryId={categoryId}
                    showCheckbox={showCheckbox}
                    isSelected={isSelected}
                />
            );
        },
        [categoryId, isTournamentSelected, showCheckbox, sportId, sportSlug],
    );

    return <>{tournaments.map(renderTournament)}</>;
};

export default memo(PrematchAllTournamentsContainer);
